// extracted by mini-css-extract-plugin
module.exports = {"layer":"_2787e5dfdf--layer--JZm2u"};